import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/app/[locale]/auth/AuthClientLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/brand/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/spinner.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.25_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1__react@19.0.3/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.25_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1__react@19.0.3/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
